import { DataViewBlockSchemaExtension } from '@blocksuite/hive-block-data-view';
import { DatabaseSelectionExtension } from '@blocksuite/hive-block-database';
import { EmbedIframeConfigExtensions } from '@blocksuite/hive-block-embed';
import { ImageStoreSpec } from '@blocksuite/hive-block-image';
import { SurfaceBlockSchemaExtension } from '@blocksuite/hive-block-surface';
import { TableSelectionExtension } from '@blocksuite/hive-block-table';
import {
  AttachmentBlockSchemaExtension,
  BookmarkBlockSchemaExtension,
  CalloutBlockSchemaExtension,
  CodeBlockSchemaExtension,
  DatabaseBlockSchemaExtension,
  DividerBlockSchemaExtension,
  EdgelessTextBlockSchemaExtension,
  EmbedFigmaBlockSchemaExtension,
  EmbedGithubBlockSchemaExtension,
  EmbedHtmlBlockSchemaExtension,
  EmbedIframeBlockSchemaExtension,
  EmbedLinkedDocBlockSchemaExtension,
  EmbedLoomBlockSchemaExtension,
  EmbedSyncedDocBlockSchemaExtension,
  EmbedYoutubeBlockSchemaExtension,
  FrameBlockSchemaExtension,
  ImageBlockSchemaExtension,
  LatexBlockSchemaExtension,
  ListBlockSchemaExtension,
  NoteBlockSchemaExtension,
  ParagraphBlockSchemaExtension,
  RootBlockSchemaExtension,
  SurfaceRefBlockSchemaExtension,
  TableBlockSchemaExtension,
  TranscriptionBlockSchemaExtension,
} from '@blocksuite/hive-model';
import {
  HighlightSelectionExtension,
  ImageSelectionExtension,
} from '@blocksuite/hive-shared/selection';
import {
  BlockMetaService,
  EmbedIframeService,
  FeatureFlagService,
  FileSizeLimitService,
  LinkPreviewerService,
} from '@blocksuite/hive-shared/services';
import {
  BlockSelectionExtension,
  CursorSelectionExtension,
  SurfaceSelectionExtension,
  TextSelectionExtension,
} from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';

import {
  getAdapterFactoryExtensions,
  getHtmlAdapterExtensions,
  getMarkdownAdapterExtensions,
  getNotionHtmlAdapterExtensions,
  getPlainTextAdapterExtensions,
} from '../adapters/extension.js';

export const StoreExtensions: ExtensionType[] = [
  CodeBlockSchemaExtension,
  ParagraphBlockSchemaExtension,
  RootBlockSchemaExtension,
  ListBlockSchemaExtension,
  NoteBlockSchemaExtension,
  DividerBlockSchemaExtension,
  ImageBlockSchemaExtension,
  SurfaceBlockSchemaExtension,
  BookmarkBlockSchemaExtension,
  FrameBlockSchemaExtension,
  DatabaseBlockSchemaExtension,
  SurfaceRefBlockSchemaExtension,
  DataViewBlockSchemaExtension,
  AttachmentBlockSchemaExtension,
  EmbedSyncedDocBlockSchemaExtension,
  EmbedLinkedDocBlockSchemaExtension,
  EmbedHtmlBlockSchemaExtension,
  EmbedIframeBlockSchemaExtension,
  EmbedGithubBlockSchemaExtension,
  EmbedFigmaBlockSchemaExtension,
  EmbedLoomBlockSchemaExtension,
  EmbedYoutubeBlockSchemaExtension,
  EdgelessTextBlockSchemaExtension,
  LatexBlockSchemaExtension,
  TableBlockSchemaExtension,
  CalloutBlockSchemaExtension,
  TranscriptionBlockSchemaExtension,

  BlockSelectionExtension,
  TextSelectionExtension,
  SurfaceSelectionExtension,
  CursorSelectionExtension,
  HighlightSelectionExtension,
  ImageSelectionExtension,
  DatabaseSelectionExtension,
  TableSelectionExtension,

  getHtmlAdapterExtensions(),
  getMarkdownAdapterExtensions(),
  getNotionHtmlAdapterExtensions(),
  getPlainTextAdapterExtensions(),
  getAdapterFactoryExtensions(),

  FeatureFlagService,
  LinkPreviewerService,
  FileSizeLimitService,
  ImageStoreSpec,
  BlockMetaService,
  EmbedIframeConfigExtensions,
  EmbedIframeService,
].flat();
